import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCogs, faBoxOpen, faShippingFast, faPiggyBank, faMapMarkerAlt, faEnvelope, faMobileAlt, faUserTie, faAt, faChevronUp, faLightbulb, faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VeeValidate from 'vee-validate'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDCsZw0JRNClubCTJl4olcXMvS8cXp4_vM',
    libraries: 'places'
  }
})

library.add(faCogs, faBoxOpen, faShippingFast, faPiggyBank, faMapMarkerAlt, faEnvelope, faMobileAlt, faUserTie, faAt, faChevronUp, faLightbulb, faThumbsUp)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VeeValidate, { fieldsBagName: 'formFields' })
Vue.use(BootstrapVue)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
